import { Icon } from "@mui/material";
// import WDAvatar from "../../MaterialComponents/WDAvatar"; // Commented out - unused
// import profilePicture from "../../assets/images/team-5.jpg"; // Commented out - unused
import { RiHandCoinFill, RiHandHeartFill } from "react-icons/ri";
import { BsTicketPerforatedFill, BsWalletFill } from "react-icons/bs";
import { /* FaFileInvoiceDollar, */ FaUserCog } from "react-icons/fa";
import { GiSettingsKnobs } from "react-icons/gi";
import { MdWorkOutline } from "react-icons/md";
import { BiErrorCircle } from "react-icons/bi";

console.log('📋 [AdminRoute] Loading admin routes - UPDATED VERSION WITH SECTION TITLES');

const adminRoute = [
  {
    type: "collapse",
    name: "Dashboards",
    key: "ADM-Dash",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "Customer Dashboard",
        key: "customer",
        route: "ADM-Dash/customer",
      },
      {
        name: "Partner Dashboard",
        key: "partner",
        route: "ADM-Dash/partner",
      },
    ],
  },
  {
    type: "collapse",
    name: "Customers",
    key: "ADM-Customer",
    icon: <Icon fontSize="medium">group-minus</Icon>,
    collapse: [
      {
        name: "New Organisation",
        key: "adm-new-customer-organisation",
        route: "ADM-Customer/adm-new-customer-organisation",
      },
      {
        name: "Organisation List",
        key: "adm-customer-organisations",
        route: "ADM-Customer/adm-customer-organisations",
      },
      {
        name: "New User",
        key: "adm-new-customer-user",
        route: "ADM-Customer/adm-new-customer-user",
      },
      {
        name: "User List",
        key: "adm-customer-users",
        route: "ADM-Customer/adm-customer-users",
      },
      {
        name: "Service Mapping List",
        key: "adm-customer-service-mappings",
        route: "ADM-Customer/adm-customer-service-mappings",
      },
      {
        name: "Service Mapping",
        key: "adm-customer-service-mapping",
        route: "ADM-Customer/adm-customer-service-mapping",
      },
      // {
      //   name: "Pending Tickets",
      //   key: "pending-customer-tickets",
      //   route: "ADM-Customer/pending-customer-tickets",
      // },
    ],
  },
  {
    type: "collapse",
    name: "Partners",
    key: "ADM-Partner",
    icon: <Icon fontSize="medium">handshake</Icon>,
    collapse: [
      {
        name: "Organisations",
        key: "adm-partner-organisations",
        route: "ADM-Partner/adm-partner-organisations",
      },
      {
        name: "New Organisation",
        key: "adm-new-partner-organisation",
        route: "ADM-Partner/adm-new-partner-organisation",
      },
      {
        name: "Users",
        key: "adm-partner-users",
        route: "ADM-Partner/adm-partner-users",
      },
      {
        name: "New User",
        key: "adm-new-partner-user",
        route: "ADM-Partner/adm-new-partner-user",
      },
      {
        name: "Service Mapping",
        key: "adm-partner-service-mapping",
        route: "ADM-Partner/adm-partner-service-mapping",
      },
      {
        name: "Service Mappings",
        key: "adm-partner-service-mappings",
        route: "ADM-Partner/adm-partner-service-mappings",
      },
      // {
      //   name: "Pending Payments",
      //   key: "pending-payments",
      //   route: "ADM-Partner/pending-payments",
      // },
      // {
      //   name: "Pending Tickets",
      //   key: "pending-tickets",
      //   route: "ADM-Partner/pending-tickets",
      // },
    ],
  },
  {
    type: "collapse",
    name: "Channel Partners",
    key: "ADM-ChannelPartners",
    icon: <Icon fontSize="medium">groups</Icon>,
    collapse: [
      {
        name: "Channel Partner List",
        key: "adm-channel-partner-list",
        route: "ADM-ChannelPartners/adm-channel-partner-list",
      },
      {
        name: "New Channel Partner",
        key: "adm-new-channel-partner",
        route: "ADM-ChannelPartners/adm-new-channel-partner",
      },
      {
        name: "Commission Config",
        key: "adm-commission-config",
        route: "ADM-ChannelPartners/adm-commission-config",
      },
      {
        name: "Partner Details",
        key: "adm-channel-partner-detail",
        route: "ADM-ChannelPartners/adm-channel-partner-detail",
      },
      {
        name: "Users",
        key: "adm-channel-partner-users",
        route: "ADM-ChannelPartners/adm-channel-partner-users",
      },
      {
        name: "New User",
        key: "adm-new-channel-partner-user",
        route: "ADM-ChannelPartners/adm-new-channel-partner-user",
      },
    ],
  },
  // { type: "title", title: "Service Group", key: "title-docs" },
  {
    type: "collapse",
    name: "Service Group",
    key: "ADM-ServiceGroup",
    // icon: <Icon fontSize="medium">group-work</Icon>,
    icon: <RiHandCoinFill />,
    collapse: [
      {
        name: "Service Groups",
        key: "adm-serviceGroups",
        route: "ADM-ServiceGroup/adm-serviceGroups",
      },
      {
        name: "New Service Group",
        key: "adm-new-serviceGroup",
        route: "ADM-ServiceGroup/adm-new-serviceGroup",
      },
    ],
  },
  {
    type: "collapse",
    name: "Service",
    key: "ADM-Service",
    icon: <RiHandHeartFill />,
    collapse: [
      {
        name: "New Service",
        key: "adm-new-service",
        route: "ADM-Service/adm-new-service",
      },
      {
        name: "List",
        key: "adm-services",
        route: "ADM-Service/adm-services",
      },
    ],
  },
  {
    type: "collapse",
    name: "Ticket",
    key: "ADM-Ticket",
    icon: <BsTicketPerforatedFill />,
    collapse: [
      {
        name: "All Tickets",
        key: "pending-tickets",
        route: "ADM-Ticket/pending-tickets",
      },
      {
        name: "On Behalf Ticket",
        key: "on-behalf-ticket",
        route: "ADM-Ticket/on-behalf-ticket",
      },
      {
        name: "Reply Form",
        key: "reply-form",
        route: "ADM-Ticket/reply-form",
      },
      {
        name: "Close On Behalf Ticket",
        key: "close-on-behalf-ticket",
        route: "ADM-Ticket/close-on-behalf-ticket",
      },
    ],
  },
  {
    type: "collapse",
    name: "Account",
    key: "ADM-Account",
    icon: <Icon>account_circle</Icon>,
    collapse: [
      /* {
        name: "Account Management",
        key: "account-management",
        route: "account/management",
      }, */
      {
        name: "Customer Wallets",
        key: "customer-wallets",
        route: "wallet/customer-wallets",
      },
      {
        name: "Service Partner Payments",
        key: "service-partner-payments",
        route: "wallet/service-partner-payments",
      },
      {
        name: "Channel Partner Commissions",
        key: "channel-partner-payments",
        route: "wallet/channel-partner-commissions",
      },
      {
        name: "Customer Payments",
        key: "customer-payments",
        route: "wallet/customer-payments",
      },
      {
        name: "Transaction History",
        key: "transaction-history",
        route: "wallet/transaction-history",
      },
      {
        name: "Pending Approvals",
        key: "pending-approvals",
        route: "wallet/pending-approvals",
      },
      {
        name: "Statements",
        key: "statements",
        route: "account/statements",
      },
    ],
  },
  {
    type: "collapse",
    name: "Finance & Operations",
    key: "ADM-Finance",
    icon: <Icon fontSize="medium">account_balance</Icon>,
    collapse: [
      // ========== MONEY MANAGEMENT ==========
      { type: "title", title: "Money Management", key: "title-money-mgmt" },
      {
        name: "Finance Overview",
        key: "finance-overview",
        route: "admin/finance/overview",
        description: "Unified Thaklis financial dashboard with all metrics"
      },
      {
        name: "Service Partner Payments",
        key: "finance-partner-payments",
        route: "ADM-Partner/partner-payment",
        description: "Manage payments to service partners for completed tickets"
      },
      {
        name: "Payment Approvals",
        key: "finance-payment-approvals",
        route: "admin/finance/payment-approvals",
        description: "Review and approve pending customer payments"
      },
      {
        name: "Bank Accounts",
        key: "finance-bank-accounts",
        route: "admin/finance/bank-accounts",
        description: "Manage Thaklis bank accounts and view transaction history"
      },
      {
        name: "Master Wallet",
        key: "finance-master-wallet",
        route: "admin/finance/master-wallet",
        description: "Thaklis master wallet - offline transactions, approvals, bank reconciliation"
      },

      // ========== ANALYTICS & REPORTS ==========
      { type: "title", title: "Analytics & Reports", key: "title-analytics" },
      {
        name: "Finance Analytics",
        key: "finance-analytics",
        route: "admin/finance/dashboard",
        description: "Advanced analytics: service profitability trends, top services, payment distribution"
      },
      {
        name: "Commission Payments",
        key: "finance-commissions",
        route: "admin/finance/commissions",
      },

      // ========== CONFIGURATION ==========
      { type: "title", title: "Configuration", key: "title-finance-config" },
      {
        name: "Payment Gateways",
        key: "payment-gateways",
        route: "admin/payment-gateways",
      },
      {
        name: "Gateway Customer Config",
        key: "customer-gateway-config",
        route: "admin/customer-gateway-config",
      },
      {
        name: "Payment Methods",
        key: "payment_methods",
        route: "ADM-Wallet/payment_methods",
      },

      // ========== GUIDES & DOCS ==========
      { type: "title", title: "Documentation", key: "title-finance-docs" },
      {
        name: "Payment Flow Guide",
        key: "finance-payment-flow",
        route: "admin/finance/payment-flow",
      },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "Invoice",
  //   key: "ADM-Invoice",
  //   icon: <FaFileInvoiceDollar />,
  //   collapse: [
  //     {
  //       name: "Invoice Requests",
  //       key: "invoice-request",
  //       route: "ADM-Invoice/invoice-request",
  //     },
  //   ],
  // },
  {
    type: "collapse",
    name: "Workflow Management",
    key: "ADM-Workflow",
    icon: <MdWorkOutline />,
    collapse: [
      {
        name: "Workflow List",
        key: "list",
        route: "ADM-Workflow/list",
      },
      {
        name: "Workflow Instances",
        key: "instances",
        route: "ADM-Workflow/instances",
      },
    ],
  },
  {
    type: "collapse",
    name: "Subscriptions",
    key: "ADM-SubscriptionPlans",
    icon: <RiHandCoinFill />,
    collapse: [
      {
        name: "Plans",
        key: "subscription-plans",
        route: "ADM-SubscriptionPlans",
      },
      {
        name: "Organisation Subscriptions",
        key: "org-subscriptions",
        route: "ADM-OrgSubscriptions",
      },
    ],
  },
  {
    type: "collapse",
    name: "User Management",
    key: "ADM-USER-MGMNT",
    icon: <FaUserCog />,
    collapse: [
      {
        name: "Change Password",
        key: "change-password",
        route: "ADM-USER-MGMNT/change-password",
      },
      {
        name: "Reset Password",
        key: "reset_password",
        route: "ADM-USER-MGMNT/reset_password",
      },
    ],
  },
  {
    type: "collapse",
    name: "Reports",
    key: "ADM-Reports",
    icon: <Icon fontSize="medium">bar_chart</Icon>,
    collapse: [
      { type: "title", title: "Employee Documents", key: "title-emp-docs" },
      {
        name: "Expiring Documents",
        key: "expiring-documents",
        route: "ADM-Reports/documents",
      },
      {
        name: "Missing Documents",
        key: "missing-documents",
        route: "ADM-Reports/missing-documents",
      },
      { type: "title", title: "Organization Documents", key: "title-org-docs" },
      {
        name: "Org Expiring Documents",
        key: "org-expiring-documents",
        route: "ADM-OrgDocReports/expiring",
        description: "Organization documents expiring or expired"
      },
      {
        name: "Org Missing Documents",
        key: "org-missing-documents",
        route: "ADM-OrgDocReports/missing",
        description: "Organizations with missing required documents"
      },
      { type: "title", title: "Storage", key: "title-storage" },
      {
        name: "Storage Usage",
        key: "storage-usage",
        route: "ADM-Reports/storage",
        description: "S3 storage used by each organization"
      },
    ],
  },
  {
    type: "collapse",
    name: "AI Assistant",
    key: "ADM-AIAgent",
    icon: <Icon fontSize="medium">smart_toy</Icon>,
    collapse: [
      {
        name: "Chat",
        key: "chat",
        route: "ADM-AIAgent/chat",
      },
      {
        name: "Agent Config",
        key: "config",
        route: "ADM-AIAgent/config",
      },
      {
        name: "Usage Analytics",
        key: "usage",
        route: "ADM-AIAgent/usage",
      },
    ],
  },
  {
    type: "collapse",
    name: "Agent",
    key: "ADM-AGENT",
    icon: <FaUserCog />,
    collapse: [
      {
        name: "Agent Creation",
        key: "agent-creation",
        route: "ADM-AGENT/agent-creation",
      },
      {
        name: "User List",
        key: "agent-users",
        route: "ADM-AGENT/agent-users",
      },
    ],
  },
  {
    type: "collapse",
    name: "Issues",
    key: "ADM-System",
    icon: <BiErrorCircle fontSize="medium" />,
    collapse: [
      {
        name: "Customer Reported Issues",
        key: "issues",
        route: "ADM-System/issues",
      },
    ],
  },
  {
    type: "collapse",
    name: "Configuration",
    key: "ADM-Configuration",
    icon: <GiSettingsKnobs fontSize="medium" />,
    collapse: [
      {
        name: "Document Configuration",
        key: "doc-config",
        route: "ADM-DocConfig/main",
        description: "Configure organization document types, categories, and rules"
      },
      {
        name: "Business Categories",
        key: "business-categories",
        route: "ADM-DocConfig/business-categories",
        description: "Manage industry/business categories for organizations"
      },
      {
        name: "Field Categories",
        key: "field-categories",
        route: "ADM-Configuration/main",
      },
      {
        name: "Organization Configuration",
        key: "organization-configuration",
        route: "admin/organization-config",
      },
    ],
  },
];

export default adminRoute;
